import {
  CheckCircleIcon,
  XCircleIcon,
  MinusCircleIcon,
} from "@heroicons/react/24/solid";

const StatusIcon = ({ status }) => {
  switch (status) {
    case "check":
      return <CheckCircleIcon className="w-5 h-5 text-semantic-positive-500 flex-shrink-0" />;
    case "cross":
      return <XCircleIcon className="w-5 h-5 text-semantic-negative-500 opacity-60 flex-shrink-0" />;
    case "partial":
      return <MinusCircleIcon className="w-5 h-5 text-semantic-notice-500 flex-shrink-0" />;
    default:
      return null;
  }
};

export default function ComparisonTable({
  title,
  subtitle,
  leftHeader,
  rightHeader,
  rows,
  variant = "light",
}) {
  const isDark = variant === "dark";

  return (
    <section
      className={`py-[100px] px-6 lg:px-10 ${isDark ? "bg-blue-primary-900 text-white" : "bg-base-white"}`}
    >
      <div className="max-w-[1100px] mx-auto">
        <h2
          className={`font-inter text-[24px] sm:text-[32px] lg:text-[38px] font-black tracking-[-1.5px] leading-[1.15] mb-4 text-center fade-in ${isDark ? "text-white" : ""}`}
        >
          {title}
        </h2>
        <p
          className={`font-inter text-base leading-[1.7] max-w-[700px] mx-auto mb-12 text-center fade-in ${isDark ? "text-white/60" : "text-gray-cool-500"}`}
        >
          {subtitle}
        </p>

        <div
          className={`overflow-x-auto rounded-[20px] fade-in ${isDark ? "border border-white/10" : "border border-gray-cool-200 bg-white"}`}
        >
          <table className="w-full border-collapse min-w-[640px]">
            <thead>
              <tr className={isDark ? "bg-white/[0.06]" : "bg-blue-primary-900"}>
                <th className="py-5 px-6 text-left text-sm font-bold text-white tracking-[0.3px] w-[36%]">
                  Feature
                </th>
                <th className="py-5 px-6 text-left text-sm font-bold text-white/90 tracking-[0.3px] w-[32%]">
                  {leftHeader}
                </th>
                <th className="py-5 px-6 text-left text-sm font-bold text-white/60 tracking-[0.3px] w-[32%]">
                  {rightHeader}
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr
                  key={i}
                  className={`transition-colors ${
                    isDark
                      ? "border-b border-white/[0.06] hover:bg-white/[0.02]"
                      : "border-b border-gray-cool-100 hover:bg-blue-primary-500/[0.02]"
                  } last:border-b-0`}
                >
                  <td
                    className={`py-[18px] px-6 text-sm font-semibold align-top ${isDark ? "text-white" : "text-gray-cool-900"}`}
                  >
                    {row.feature}
                  </td>
                  <td className="py-[18px] px-6 text-sm align-top">
                    <div className="flex items-start gap-2">
                      <StatusIcon status={row.leftStatus} />
                      <div>
                        {row.leftDetail && (
                          <span
                            className={`text-xs mt-0.5 leading-[1.4] ${isDark ? "text-semantic-positive-500/80" : "text-gray-cool-500"}`}
                          >
                            {row.leftDetail}
                          </span>
                        )}
                      </div>
                    </div>
                  </td>
                  <td className="py-[18px] px-6 text-sm align-top">
                    <div className="flex items-start gap-2">
                      <StatusIcon status={row.rightStatus} />
                      <div>
                        {row.rightDetail && (
                          <span
                            className={`text-xs mt-0.5 leading-[1.4] ${isDark ? "text-white/40" : "text-gray-cool-500"}`}
                          >
                            {row.rightDetail}
                          </span>
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
